import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import { InBodyProvider } from "@icoach/inbody/components/InBodyContext";
import { Box } from "@curves/ui-base";
import EmployeeInBodyEmployeeInfoSummary from "@icoach/inbody/employeeInbodyInterview/EmployeeInBodyEmployeeInfoSummary";
import EmployeeInBodyInterviewMeasureCompareTable from "@icoach/inbody/employeeInbodyInterview/EmployeeInBodyInterviewMeasureCompareTable";
import InBodyInterviewDialogBox from "@icoach/inbody/dialog/InBodyInterviewDialogBox";
import EmployeeInBodyInterviewMeasureTable from "@icoach/inbody/employeeInbodyInterview/EmployeeInBodyInterviewMeasureTable";
import useGetMeasureRecordsState from "@util/hook/useGetMeasureRecordsState";
import useGetEmployeeInformationState from "@util/hook/useGetEmployeeInformationState";
import { IN_BODY_INTERVIEW_TABS, MEASURE_REFERENCE_TYPE } from "@icoach/constants";
import { isEqual, toNumber } from "@util/utils";

const EmployeeInBodyInterviewPage = () => {
	const { referenceID: _employeeID, tabs: activeTab, referenceType: _referenceType } = useParams();
	const employeeID = toNumber(_employeeID);
	const referenceType = toNumber(_referenceType);
	const { sourceData: EmployeeInfo } = useGetEmployeeInformationState({ employeeID });
	const { measureData, validMeasureData, getInterviewMeasureApi } = useGetMeasureRecordsState({
		referenceType: MEASURE_REFERENCE_TYPE.EMPLOYEE,
		referenceID: employeeID,
	});

	const dialogRef = useRef(null);
	const refreshRef = useRef(getInterviewMeasureApi);

	return (
		<InBodyProvider
			value={{
				dialogRef,
				peopleID: employeeID,
				referenceType: referenceType,
				measureData,
				getInterviewMeasureApi,
				refresh: refreshRef.current,
				setRefresh: fn => (refreshRef.current = fn),
			}}
		>
			<Box className="container main-container-spacing inbody-interview">
				<EmployeeInBodyEmployeeInfoSummary className="mb-3" employeeID={employeeID} sourceData={EmployeeInfo} activeTab={activeTab} refresh={refreshRef.current} />
				{isEqual(activeTab, IN_BODY_INTERVIEW_TABS.COMPARE) && <EmployeeInBodyInterviewMeasureCompareTable sourceData={validMeasureData} />}
				{isEqual(activeTab, IN_BODY_INTERVIEW_TABS.MEASURE) && <EmployeeInBodyInterviewMeasureTable sourceData={validMeasureData} />}
			</Box>
			<InBodyInterviewDialogBox ref={dialogRef} />
		</InBodyProvider>
	);
};

export default EmployeeInBodyInterviewPage;
